module.exports = __webpack_public_path__ + "img/1558900019.d7e4431f.jpg";